import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

export default function MinContentCustomModal(props) {
  const [show, setShow] = useState(false);

  const clickShow = () => {
    setShow(true);
  };
  const clickClose = () => {
    setShow(false);
  };

  return (
    <>
      <p
        onClick={clickShow}
        style={{ fontSize: '14px', cursor: 'pointer', color: '#007bff' }}
      >
        {props.text}
      </p>
      {show &&
        ReactDOM.createPortal(
          <Dialog
            onClose={clickClose}
            closeIcon={props.closeIcon === undefined ? true : props.closeIcon}
            key={Math.random()}
            width={props.width === undefined ? '50%' : props.width}
            minWidth={400}
            height={props.height === undefined ? 'auto' : props.height}
            title={props.title}
          >
            {props.children}
            {props.buttons && <DialogActionsBar></DialogActionsBar>}
          </Dialog>,
          document.getElementById('modal')
        )}
    </>
  );
}

MinContentCustomModal.propTypes = {
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  width: PropTypes.any,
  height: PropTypes.any,
  closeIcon: PropTypes.any,
  children: PropTypes.any,
  buttons: PropTypes.any
};
